class VeranstaltungListenelementLeer extends HTMLElement {

  connectedCallback() {
    this.setElements();
    this.bindEvents();
    this.calculateInitialButtonMoreState();
  }

  setElements() {
    this.textElement = this.querySelectorAll(".item-text");
    this.buttonElement = this.querySelectorAll(".item-text-button");
  }

  bindEvents() {
    window.addEventListener('resize', () => this.calculateInitialButtonMoreState());
    this.buttonElement.forEach((button) => {
      button.addEventListener("click", (event) => {
        this.toggleText(event);
      });
    });
  }

  toggleText(event) {
    event.target.setAttribute("data-state", event.target.dataset.state === "more" ? "less" : "more");
    event.target.innerHTML = event.target.dataset.state === "more" ? "…weiterlesen" : "…weniger";
    event.target.previousSibling.previousSibling.setAttribute("data-state", event.target.previousSibling.previousSibling.dataset.state === "more" ? "less" : "more");
  }

  calculateInitialButtonMoreState() {
    this.buttonElement.forEach((button, index) => {
      const textElementHeight = this.textElement.item(index);
      button.style.display = (textElementHeight.scrollHeight > textElementHeight.offsetHeight) ? 'block' : 'none';
    });
  }

}

if (!customElements.get("veranstaltung-listenelement-leer")) {
  customElements.define("veranstaltung-listenelement-leer", VeranstaltungListenelementLeer);
}
